// extracted by mini-css-extract-plugin
export default {"green":"DiaryTaskIcon_green__BtNy0","orange":"DiaryTaskIcon_orange__eQ44t","red":"DiaryTaskIcon_red__1NDoK","checkmark":"DiaryTaskIcon_checkmark__DyG2O"};